import { render, staticRenderFns } from "./ssoLogin.vue?vue&type=template&id=4b676d8c&scoped=true"
import script from "./ssoLogin.vue?vue&type=script&lang=js"
export * from "./ssoLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b676d8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b676d8c')) {
      api.createRecord('4b676d8c', component.options)
    } else {
      api.reload('4b676d8c', component.options)
    }
    module.hot.accept("./ssoLogin.vue?vue&type=template&id=4b676d8c&scoped=true", function () {
      api.rerender('4b676d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssoLogin.vue"
export default component.exports